
import { Eye, EyeOff } from "lucide-react"
import "./input.css"
import { forwardRef, useState } from "react";

const CustomInout = forwardRef(({ label, error, type, ...props }, ref) => {
    const [eye, seteye] = useState(true);

    return (
        <div>
            <div className={`input-container ${error && 'input-container-error'}`}>
                <input
                    type={type === "password" ? (eye ? "password" : "text") : type}
                    className="input-field-custom"
                    placeholder=" "
                    ref={ref}         
                    {...props}       
                />
                <label className="input-label">{label}</label>
                {type === "password" && (
                    <div className="eye-position" onClick={() => seteye((state) => !state)}>
                        {eye ? <EyeOff /> : <Eye />}
                    </div>
                )}
            </div>
            {error && <div className="error-text">{error}</div>}
        </div>
    );
});


export default CustomInout